import WithLocId from "./WithLocId";

export default WithLocId;
